import { ButtonLight, ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import { CardSection } from 'components/earn/styled'
import { RowBetween } from 'components/Row'
import { LINKS } from 'constants/links'
import React from 'react'
import styled from 'styled-components'
import { TYPE } from 'theme'
import ModalWithCat from './ModalWithCat'

const Wrapper = styled.div`
  width: 100%;
  b {
    color: ${({ theme }) => theme.primary1};
  }
  p {
    color: ${({ theme }) => theme.text2};
    font-size: 14px;
    margin: 0;
  }

  img {
    width: 40px;
  }
`

const DiscordModal = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  React.useEffect(() => {
    const hasSeen = localStorage.getItem('hasSeenDiscordModal')
    window.addEventListener('storage', () => {
      if (!hasSeen) {
        setIsOpen(true)
      }
    })
  }, [])

  const handleClose = () => {
    localStorage.setItem('hasSeenDiscordModal', 'true')
    setIsOpen(false)
  }

  return (
    <>
      <ModalWithCat isOpen={isOpen} onDismiss={() => handleClose()} cat>
        <Wrapper>
          <AutoColumn>
            <CardSection gap="md">
              <RowBetween>
                <TYPE.white fontWeight={700} fontSize={20}>
                  Welcome to <b>HyperSwap Exchange!</b> 🎉
                </TYPE.white>
              </RowBetween>
              <p>
                Thank you for joining our platform. Join our community on Discord to stay updated with the latest
                features, announcements, and support!
              </p>
              <RowBetween style={{ gap: '12px' }}>
                <ButtonPrimary
                  onClick={() => {
                    window.open(LINKS.discord.link, '_blank')
                    handleClose()
                  }}
                >
                  Join Discord
                </ButtonPrimary>
                <ButtonLight onClick={() => handleClose()}>Close</ButtonLight>
              </RowBetween>
            </CardSection>
          </AutoColumn>
        </Wrapper>
      </ModalWithCat>
    </>
  )
}
export default DiscordModal
